module.exports = __webpack_public_path__ + "static/6-d784c715963189f6d8d350ff7bbbd24f.png";